import { TimelineUseCases } from '@/features/timeline/application/timeline-use-cases';
import { LocalFileTimelineRepository } from '@/features/timeline/infrastructure/local-file-timeline-repository';
import { TimelineFileService } from '@/features/timeline/infrastructure/timeline-file-service';
import { FileHandleStore } from '@/features/timeline/infrastructure/file-handle-store';
import { RecentFilesService } from '@/features/timeline/application/recent-files';

const createTimelineUseCases = (): TimelineUseCases => {
  const repository = new LocalFileTimelineRepository();
  const fileService = new TimelineFileService();
  const recentFiles = new RecentFilesService();
  const fileHandleStore = new FileHandleStore();
  return new TimelineUseCases(repository, fileService, recentFiles, fileHandleStore);
};

export const timelineUseCases = createTimelineUseCases();
